/** Must match `AiInterviewPage` consent version for POST consent. */
export const AI_INTERVIEW_CONSENT_VERSION = '2026-04-01';

/** @deprecated Use interviewTargetMinutesForSessionType — kept for any legacy copy */
export const AI_INTERVIEW_PREP_DURATION_MIN = 12;

/** Expected length (minutes) varies by round — used in prep UI and session guide. */
export function interviewTargetMinutesForSessionType(sessionType: string): number {
  switch (sessionType) {
    case 'technical':
      return 12;
    case 'behavioral':
      return 10;
    case 'screening':
    default:
      return 8;
  }
}

/** Heading / progress label for the scheduled round (must match API session_type). */
export function sessionInterviewStepLabel(sessionType: string): string {
  switch (sessionType) {
    case 'technical':
      return 'Technical interview';
    case 'behavioral':
      return 'Behavioral interview';
    case 'screening':
      return 'Screening interview';
    default:
      return 'Interview';
  }
}

/** Product copy: guided, adaptive interview (warmer than “AI screening”). */
export const AI_INTERVIEW_AGENT_HEADLINE = 'Guided interview';

export const AI_INTERVIEW_LANGUAGES: { value: string; label: string }[] = [
  { value: 'en-IN', label: 'English' },
  { value: 'hi-IN', label: 'Hindi' },
  { value: 'kn-IN', label: 'Kannada' },
  { value: 'mr-IN', label: 'Marathi' },
  { value: 'ru-RU', label: 'Russian' },
  { value: 'pt-BR', label: 'Portuguese' },
  { value: 'es-ES', label: 'Spanish' },
  { value: 'hi-EN', label: 'Hinglish (Hindi–English mix)' },
];

export const AI_INTERVIEW_SESSION_TYPES: { value: string; label: string }[] = [
  { value: 'screening', label: 'Screening' },
  { value: 'technical', label: 'Technical' },
  { value: 'behavioral', label: 'Behavioral' },
];
